import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_UNITS_REQUEST = 'FETCH_UNITS_REQUEST';
export const FETCH_UNITS_SUCCESS = 'FETCH_UNITS_SUCCESS';
export const FETCH_UNITS_FAILURE = 'FETCH_UNITS_FAILURE';

const buildUnitUrl = (groupId) => buildUrl(`/groups/${groupId}/units`);

export function fetchUnitIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildUnitUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchUnits(groupId));
  };
}

export function fetchUnits(groupId) {
  return (dispatch) => {
    const url = buildUnitUrl(groupId);
    const method = 'GET';

    return dispatch(fetchUnitsRequest()).payload
      .then((response) => dispatch(fetchUnitsSuccess(response)))
      .catch((error) => dispatch(fetchUnitsFailure(error)));

    function fetchUnitsRequest() {
      return ApiCall.createAction({
        type: FETCH_UNITS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchUnitsSuccess(units) {
      return ApiCall.createAction({
        type: FETCH_UNITS_SUCCESS,
        payload: units,
        url,
        method,
        groupId,
      });
    }

    function fetchUnitsFailure(error) {
      return ApiCall.createAction({
        type: FETCH_UNITS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Units/actions.js